const createOptionsArrayForMultiselect = {
  methods: {
    createOptionsArrayForMultiselect(obj) {
      return Object.entries(obj || {}).map((element) => ({ value: element[0], text: element[1] }));
    },
  },
};
export default createOptionsArrayForMultiselect;
